module.exports = function() {
  return new Worker(__webpack_public_path__ + "3866de4b6d602f8afcc6.worker.js");
};